import { render, staticRenderFns } from "./EnglishResumeSkillsCard.vue?vue&type=template&id=12ae7b80&scoped=true"
import script from "./EnglishResumeSkillsCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./EnglishResumeSkillsCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EnglishResumeSkillsCard.vue?vue&type=style&index=0&id=12ae7b80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ae7b80",
  null
  
)

export default component.exports